import { Handle, Position } from 'react-flow-renderer';
import { withNamespaces } from 'react-i18next';

import getStateVisuals from './stateVisuals';
import NodeHandles, { handleStyle } from './NodeHandles';

const StageNode = ({
    data,
    t,
}) => {
    const visuals = getStateVisuals(data.state);

    return (
        <>
            <NodeHandles extra={(
                <Handle id="start" position={Position.Left} style={handleStyle} type="source" />
            )} />

            <div className="d-flex align-items-center" style={{ width: 170 }}>
                <i className={`${visuals.icon} text-${visuals.color} font-size-12 me-1`} />
                <span className={`font-size-11 text-${data.state === 'pending' ? 'muted' : visuals.color}`}>
                    {t(data.label)}
                </span>
            </div>
        </>
    );
};

export default withNamespaces()(StageNode);
